export default {
  default: [
    {
      path: "/bedrijfsgegevens",
      name: "company.details",
      component: () => import("@/modules/partner/views/DetailsView.vue")
    }
  ]
};
